export function formatFinanceMoney(n: number, currency = "USD") {
  return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(n);
}

export function financeInvoiceBalance(inv: { amount?: number; amountPaid?: number }) {
  const paid = Number(inv.amountPaid) || 0;
  return Math.max(0, (Number(inv.amount) || 0) - paid);
}
